/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
//import constantName from './key'

/**
 *
 * @param {string} metaData
 * @returns
 */

export function loadRecordsMetaData(metaData, method) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//employee list
export function loadEmployeeList() {
  let payload = { status: "active" }

  return api
    .post(`/get_all_employee_filter`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}
// nightshift

export async function loadNightShiftList(applyFilter) {
  if (applyFilter) {
    return await api
      .post(`/get_all_night_shift_apply`, applyFilter)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return await api
      .post(`/get_all_night_shift_apply`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

//UPDATE NIGHTSHIFT
export async function updateNightShiftList(update_Nightshift) {
  return await api
    .post(`/editNightShift`, update_Nightshift)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//update lpnd

export async function updateLpndList(update_Lpnd) {
  return await api
    .put(`/update_lpnd_request`, update_Lpnd)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//delete

export function deleteNightshift(deleteData) {
  return api
    .put(`/deleteNightShift`, deleteData)
    .catch((error) => Promise.reject(error))
}

//UPDATE LPND
export async function applyNightShiftDetailsList(applyNightShiftDetails) {
  console.log("inside saga", applyNightShiftDetails)
  return await api
    .post(`/applyNightShift`, applyNightShiftDetails)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecordsMetaData,
  loadEmployeeList,
  loadNightShiftList,
  updateNightShiftList,
  updateLpndList,
  deleteNightshift,
  applyNightShiftDetailsList,
}

export default remotes
